import apiCaller, { wrap } from '../../utils/ApiClient';
import * as constants from './constants';
import { ACTION } from '../../types';

export const getSearchResults = (payload) =>
  wrap((dispatch) => {
    try {
      const parameters = new URLSearchParams(payload);
      return apiCaller('GET', `searchterm?${parameters.toString()}`, undefined, {}, payload.signal).then((resData) => {
        dispatch({ type: constants.SEARCH_RESULT, payload: resData });
        return resData;
      });
    } catch (err) {
      const error = err as Error;
      if (error.name === 'AbortError') {
        console.log('Search request was aborted');
        return;
      }
      if (!String(err as any).includes('The user aborted a request')) {
        console.error('error: ', err);
        throw err;
      }
    }
  }, 'GET_ERROR');

export const setShowIsUnavailable = (payload: any): ACTION => ({
  type: constants.UPDATE_AVAILABILITY,
  payload,
});
export const addLocation = (payload: any): ACTION => ({
  type: constants.ADD_LOCATION,
  payload,
});
export const updateLocation = (payload: any): ACTION => ({
  type: constants.UPDATE_LOCATION,
  payload,
});
export const removeLocation = (payload: any): ACTION => ({
  type: constants.REMOVE_LOCATION,
  payload,
});

export const setSearchParameters = (payload) => ({
  type: constants.SET_SEARCH_PARAMS,
  payload,
});

export const resetAllSearch = () => ({
  type: constants.RESET_ALL,
});
